// GraphQL queries for user operations

export const GET_USER = /* GraphQL */ `
  query GetUser {
    getUser {
      id
      email
      firstName
      lastName
      nickname
      pictureUrl
      birthDate
      address
      phoneNumber
      locale
      zone
      lastSeenAt
      createdAt
    }
  }
`;

// Keep the old name for backward compatibility
export const GET_USER_BY_EMAIL = GET_USER;

